import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  input: {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      cursor: 'pointer',
    },

    disabled: {
      cursor: 'default',
    },
  },

  checkIcon: {
    verticalAlign: 'text-top',
  },

  base: {
    display: 'block',
    alignItems: 'center',
    width: '100%',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    backgroundColor: 'white',
    cursor: 'pointer',
    ...theme.typography.body,
  },
  hover: {
    backgroundColor: '#f7f9fb',
  },
  checked: {
    color: '#298bff',
  },

  selected: {
    backgroundColor: '#f7f9fb',
  },
  disabled: {
    color: theme.colors.text.dimmed,
    cursor: 'default',
  },

  isChecklistItem: {
    borderBottom: 'none',
  },

  variants: {
    primary: {
      color: '#02bb4f',
      fontWeight: 600,
    },
    secondary: {
      color: '#404e59',
      fontWeight: 600,
    },
    cta: {
      color: '#298bff',
      fontWeight: 600,
    },
    title: {
      borderBottom: theme.settings.borders.regular,
      fontWeight: 400,
      cursor: 'default',
      ':hover': {
        backgroundColor: 'white',
      },
    },
  },

  button: {
    paddingTop: theme.settings.spacing.small,
    paddingRight: theme.settings.spacing.medium,
    paddingBottom: theme.settings.spacing.small,
    paddingLeft: theme.settings.spacing.medium,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '60px',

    ':focus': {
      outlineOffset: '-5px',
    },
  },
})
